export default {
	computed: {
		appModel() {
			return this.$store.state.app;
		},

		store() {
			return this.$store;
		},
		state() {
			return this.$store.state;
		},
		routeName() {
			return this.$route.name;
		},
	},
};
